export default __webpack_public_path__ + "static/media/G0350.34I-26156_-17337_0.1666262160000.aaa15942.jpg";